import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
    Cart,
    Client,
    ClientOption,
    ListFiles
} from '@app/core/services/api/API.service';
import { CartService } from '@app/core/api/services';
import { hasValidDeliveryAddresses } from '@app/shared/services/util.service';

export function generatePremiumCartFileName(
    fileName: string,
    onePath: string,
    secondPath: string,
    thirdPath: string,
    date: string,
    indexFile: number,
    optionalPath?: string
) {
    let path = '';
    if (optionalPath) {
        path = `${onePath}/${secondPath}/${optionalPath}/${thirdPath}-${date}-${indexFile}-${fileName
            .trim()
            .toLowerCase()
            .split(' ')
            .join('-')}`;
    } else {
        path = `${onePath}/${secondPath}/${thirdPath}-${date}-${indexFile}-${fileName
            .trim()
            .toLowerCase()
            .split(' ')
            .join('-')}`;
    }
    return path;
}

/** Archivos de brandeo en carrito premium (step branding y drawer add-premium-cart-file-brand). */
export function isPremiumCartBrandingFile(file: ListFiles): boolean {
    const key = file?.file?.key;
    if (!key || typeof key !== 'string') {
        return false;
    }
    if (key.includes('address')) {
        return false;
    }
    return key.includes('/branding/') || key.includes('brand');
}

export function filterPremiumCartBrandingFiles(
    files: ListFiles[] | null | undefined
): ListFiles[] {
    return (files ?? []).filter(isPremiumCartBrandingFile);
}

@Injectable({
    providedIn: 'root'
})
export class PremiumsService {
    public isCartValid(
        cart: Cart,
        client: Client,
        clientOption: ClientOption
    ): boolean {
        console.log(clientOption.logisticPrices);

        if (clientOption.logisticPrices) {
            return (
                this.hasValidRequirement(cart) &&
                this.hasDeliveryAddresses(cart)
            );
        } else {
            return this.hasValidRequirement(cart);
        }
    }

    public hasValidContact(cart: Cart): boolean {
        if (!cart || !cart.contact) {
            return false;
        }
        const { name, tel } = cart.contact;
        return (
            name !== null &&
            tel !== null &&
            name.trim() !== '' &&
            tel.trim() !== ''
        );
    }

    public hasValidRequirement(cart: Cart): boolean {
        return cart && cart.requirement && cart.requirement.trim() !== '';
    }

    public hasDeliveryAddresses(cart: Cart): boolean {
        return hasValidDeliveryAddresses(cart?.delivery_addresses);
    }

    public hasBrandingFiles(cart: Cart): boolean {
        if (!cart?.files?.length) {
            return false;
        }
        return filterPremiumCartBrandingFiles(cart.files).length > 0;
    }
}
